import React from "react";
import ShopSection from "../components/ShopSection";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const ShopPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Shop" />
      <ShopSection />
    </>
  );
};

export default ShopPage;